document.addEventListener("DOMContentLoaded", function() {
    var target = document.querySelector('body');
    var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        if(mutation.type == 'childList' && document.querySelector('.easytabs-container')){
        observer.disconnect();
        let easySecondSection = document.querySelector('.easytabs-container .second-section');
        if(easySecondSection && !easySecondSection.classList.contains('easy-find') ){
            easySecondSection.classList.add("easy-find");
            const button = document.createElement('button');
            button.classList.add("easy-btn");
            button.textContent = 'Read more';
            button.addEventListener('click', () => {
                if (!easySecondSection.classList.contains('easy-active')) {
                    easySecondSection.classList.add("easy-active");
                    button.textContent = 'Read less';
                } else {
                    easySecondSection.classList.remove("easy-active");
                    button.textContent = 'Read more';
                }
            });
            easySecondSection.insertAdjacentElement('afterend', button);
        }
        const summaryMeta = document.querySelector('.easy-product-summary-metadata');
        let firstTab = document.querySelector('.easytabs-accordion-item');
        if (summaryMeta && summaryMeta.innerHTML.trim() !== '' && firstTab ) {
            firstTab.click();    
        }
        }
    });    
    });
    var config = { attributes: true, childList: true, characterData: true };
    observer.observe(target,  config);
});